import React from 'react';
import Checkbox from 'material-ui/Checkbox';
import classNames from 'classnames';

export default class CheckboxField extends React.PureComponent {
  render() {
    return (
      <div className={classNames(this.props.className, 'ev-checkbox-field')}>
        <Checkbox {...this.props} />
      </div>
    );
  }
}
